export const formatText = (data: any) => {
	const parser = new DOMParser()

	if (!data) return []

	const resultRegExp = /(<(\/?[^>]+)>)/g.test(data)
	const formatedText = resultRegExp
		? data
		: data.replace(/(.+?)(\n|$)+/g, '<p>$1</p>')
	const htmlDoc = parser.parseFromString(formatedText, 'text/html')

	const textArr: any = []

	const formater = (elem: any) => {
		elem.childNodes.forEach((a: any) => {
			if (a.localName === 'ul') {
				const ulArr = []
				a.childNodes.forEach((x: any) =>
					ulArr.push({
						tag: x.localName ? x.localName : 'p',
						text: x.innerText ? x.innerText : '...',
					})
				)
				textArr.push({
					tag: 'ulArr',
					text: ulArr,
				})
			}
			textArr.push({
				tag: a.localName ? a.localName : 'p',
				text: a.innerText ? a.innerText : '...',
			})
		})
	}

	formater(htmlDoc.body)

	return textArr.filter((x: any) => x.tag !== 'ul')
}
